<template>
  <div>
    <div v-if="!loading">
    <TextFormGroup
        :value="value.headline"
        name="headline"
        label="Headline Override"
        help-text="Override the headline of the block."
        :error="(errors.headline || [])[0]"
        @input="emit('headline', $event)"
    />

    <TextareaFormGroup
        :value="value.text"
        name="text"
        label="Text Override"
        help-text="Override the text of the block."
        :error="(errors.text || [])[0]"
        @input="emit('text', $event)"
    />

    <TextFormGroup
        :value="value.path"
        name="path"
        label="Path Override"
        help-text="Override the path to the terms and conditions for signing up to the newsletter."
        :error="(errors.path || [])[0]"
        @input="emit('path', $event)"
    />

    <SelectFormGroup
        :value="value.list_reference"
        name="list_reference"
        label="List Override"
        help-text="Override the mailing list to sign visitors up for when submitting the signup form.."
        :error="(errors.list_reference || [])[0]"
        :options="mailingListOptions"
        :nullable="true"
        @input="emit('list_reference', $event)"
    />

    <GalleryFormGroup
        :value="value.image_id"
        name="image_id"
        label="Image"
        :error="(errors.image_id || [])[0]"
        :nullable="true"
        @input="emit('image_id', $event)"
    />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import GalleryFormGroup from "../../../../components/FormGroups/Block/Gallery"
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'
import TextareaFormGroup from '@/vendor/forms/FormGroups/Block/Textarea'

export default {
  components: {GalleryFormGroup,SelectFormGroup,TextFormGroup,TextareaFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    }
  },

  data() {
    return {
      loading: true,
      mailingLists: []
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    mailingListOptions() {
      return this.mailingLists.map(mailingList => {
        return {
          value: mailingList.id,
          label: mailingList.attributes.name
        }
      })
    },
  },

  methods: {
    load() {
      http.get('/api/v2/external/mailing-lists')
          .then(response => {
            this.mailingLists = response.data.data

            this.loading = false
          })
    },

    emit(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    }
  }
}
</script>
